export { default } from './doctorInfo';
